import { FETCH_COUNTRIES } from '../types';

const INITIAL_STATE = {
  countries: [], // array of country objects from API
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COUNTRIES:
      return { ...state, countries: action.payload };
    default:
      return state;
  }
};
